import { RxCollectionCreator } from 'rxdb';

export const allEndUserSchema: RxCollectionCreator = {
	schema: {
		title: 'End User schema',
		description: 'create a End user schema',
		version: 1,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			name: {
				type: 'string',
			},
			phone: {
				type: ['string', 'null'],
			},
			endusercategory_c: {
				type: 'string',
			},
			source_c: {
				type: 'string',
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
			lastmodifieddate: { type: ['string', 'null'] },
			points_banked: {
				type: ['number', 'null'],
			},
			membershipno_c: {
				type: 'string',
			},
			adoptedby_c: {
				type: 'string',
			},
			status: {
				type: ['string', 'null'],
			},
			club_mapping_c: {
				type: 'string',
			},
			app_id_c: {
				type: 'string',
			},
			physical_verification_status: {
				type: 'string',
			},
			variable_contractor_type_c: {
				type: 'string',
			},
			primary_contractor_c: {
				type: 'string',
			},
			nameofthefirm_c: {
				type: ['string', 'null'],
			},
		},
		required: [
			'id',
			'sfid',
			'name',
			'phone',
			'endusercategory_c',
			'source_c',
			'createddate',
			'lastmodifieddate',
			'points_banked',
			'status',
			'app_id_c',
			'club_mapping_c',
			'physical_verification_status',
			'variable_contractor_type_c',
			'primary_contractor_c',
		],
	},
	migrationStrategies: {
		1: (oldDoc: Record<string, unknown>): Record<string, unknown> => ({
			...oldDoc,
			nameofthefirm_c: typeof oldDoc.nameofthefirm_c === 'string' ? oldDoc.nameofthefirm_c : null,
		}),
	},
};
